import request from '@/utils/request'

let SuggestionApi = {
  /*素材列表*/
  suggestionList(data, errorback) {
    return request._get('/shop/plus.suggestion.suggestion/index', data, errorback);
  },
  /*添加素材*/
  toAddsuggestion(data, errorback) {
    return request._get('/shop/plus.suggestion.suggestion/add', data, errorback);
  },
  /*素材添加*/
  suggestionAdd(data, errorback) {
    return request._post('/shop/plus.suggestion.suggestion/add', data, errorback);
  },
  /*编辑素材*/
  toEditsuggestion(data, errorback) {
    return request._get('/shop/plus.suggestion.suggestion/edit', data, errorback);
  },
  /*素材编辑*/
  suggestionEdit(data, errorback) {
    return request._post('/shop/plus.suggestion.suggestion/edit', data, errorback);
  },
  /*素材删除*/
  suggestionDel(data, errorback) {
    return request._post('/shop/plus.suggestion.suggestion/delete', data, errorback);
  },
  /*获取素材分类*/
  getCategory(data, errorback) {
    return request._post('/shop/plus.suggestion.category/index', data, errorback);
  },
  /*添加分类*/
  addCategiry(data, errorback) {
    return request._post('/shop/plus.suggestion.category/add', data, errorback);
  },
  /*编辑分类*/
  editCategory(data, errorback) {
    return request._post('/shop/plus.suggestion.category/edit', data, errorback);
  },
  /*删除分类*/
  deleteCategory(data, errorback) {
    return request._post('/shop/plus.suggestion.category/delete', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.suggestion.suggestion/setting', data, errorback);
  },
  /*保存设置*/
  setSetting(data, errorback) {
    return request._post('/shop/plus.suggestion.suggestion/setting', data, errorback);
  },
}
export default SuggestionApi;



// WEBPACK FOOTER //
// ./src/api/suggestion.js